import {createActions} from "../../../baseClasses/ActionFactory";
import WarningService from '../../../services/WarningService';

function onFetch(id) {
  WarningService.fetch(id);
}

const {types, actions} = createActions({store: 'WARNINGS', onFetch});
export {actions, types};
